import React from 'react';
import './BasePopup.css';

const BasePopup = ({ 
  visible, 
  title, 
  children, 
  onCancel, 
  onSave, 
  saveText = "Save",
  width = "500px", /* Set a default fixed width instead of percentage */
  maxWidth = "500px"
}) => {
  if (!visible) return null;
  
  return (
    <div className="base-popup-overlay" onClick={onCancel}>
      <div 
        className="base-popup-content" 
        onClick={e => e.stopPropagation()}
        style={{ width, maxWidth }}
      >
        <div className="base-popup-header">
          <h2>{title}</h2>
          <button className="base-popup-close" onClick={onCancel}>×</button>
        </div>
        
        <div className="base-popup-body">
          {children}
        </div>
        
        <div className="base-popup-footer">
          <button className="base-popup-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="base-popup-save" onClick={onSave}>
            {saveText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BasePopup;